<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <VIPLevelPaymentTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import VIPLevelPaymentTable from './VIPLevelPaymentTable.vue'

  export default {
    name: 'vipLevelPayment',
    components: {VIPLevelPaymentTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelPayment.vue